import React from 'react'

const Cis9 = () => {
    return (
        <div className='container'>
        <h1>How to check if a given array represents a Binary Heap?</h1>
        <p>Given an array, how to check if the given array represents a Binary Max-Heap.</p>
<p>
        <strong>Examples:</strong>&nbsp;</p>
        <pre className='containers'>{`Input:  arr[] = &#123;90, 15, 10, 7, 12, 2&#125; 
Output: True 
The given array represents below tree 
       90 
     /    \ 
   15      10 
  /  \     / 
 7    12  2  
The tree follows max-heap property as every 
node is greater than all of its descendants. 
 
Input:  arr[] = &#123;9, 15, 10, 7, 12, 11&#125; 
Output: False 
The given array represents below tree 
       9 
     /    \ 
   15      10 
  /  \     / 
 7    12  11 
The tree doesn't follows max-heap property 9 is  
smaller than 15 and 10, and 10 is smaller than 11. `}</pre> 
<p>A <strong>Simple Solution</strong> is to first check root if it’s greater than all of its descendants. Then check for children of the root. Time complexity of this solution is O(n<sup>2</sup>)<br/>
An <strong>Efficient Solution</strong> is to compare root only with its children (not all descendants), if root is greater than its children and the same is true for all nodes, then tree is max-heap (This conclusion is based on transitive property of &gt; operator, i.e., if x &gt; y and y &gt; z, then x &gt; z).<br/>
The last internal node is present at index (n-2)/2 assuming that indexing begins with 0.<br/>
Below is the implementation of this solution.&nbsp;</p>

         <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>



<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C program to check whether a given array</code>
    </div>
    <div class="line number2 index1 alt1"><code class="comments">// represents a max-heap or not</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;limits.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">// Returns true if arr[i..n-1] represents a</code>
    </div>
    <div class="line number7 index6 alt2"><code class="comments">// max-heap</code></div>
    <div class="line number8 index7 alt1"><code class="color1 bold">bool</code> <code class="plain">isHeap(</code><code
            class="color1 bold">int</code> <code class="plain">arr[], </code><code class="color1 bold">int</code> <code
            class="plain">i, </code><code class="color1 bold">int</code> <code class="plain">n)</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If a leaf node</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(i &gt;= (n - 2) / 2)</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="keyword bold">true</code><code class="plain">;</code></div>
    <div class="line number13 index12 alt2">&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If an internal node and is</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// greater than its children,</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// and same is recursively</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// true for the children</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(arr[i] &gt;= arr[2 * i + 1] &amp;&amp;</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">arr[i] &gt;= arr[2 * i + 2]</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&amp;&amp; isHeap(arr, 2 * i + 1, n)</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&amp;&amp; isHeap(arr, 2 * i + 2, n))</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="keyword bold">true</code><code class="plain">;</code></div>
    <div class="line number23 index22 alt2">&nbsp;</div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="keyword bold">false</code><code class="plain">;</code></div>
    <div class="line number25 index24 alt2"><code class="plain">&#125;</code></div>
    <div class="line number26 index25 alt1">&nbsp;</div>
    <div class="line number27 index26 alt2"><code class="comments">// Driver program</code></div>
    <div class="line number28 index27 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number29 index28 alt2"><code class="plain">&#123;</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">arr[] = &#123; 90, 15, 10, 7, 12, 2, 7, 3 &#125;;</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">n = </code><code class="keyword bold">sizeof</code><code
            class="plain">(arr) / </code><code class="keyword bold">sizeof</code><code class="plain">(</code><code
            class="color1 bold">int</code><code class="plain">) - 1;</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">isHeap(arr, 0, n) ? </code><code class="functions bold">printf</code><code
            class="plain">(</code><code class="string">"Yes"</code><code class="plain">) : </code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"No"</code><code
            class="plain">);</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number36 index35 alt1"><code class="plain">&#125;</code></div>
</div>
 </div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// Java program to check whether a given array</code>
    </div>
    <div class="line number2 index1 alt1"><code class="comments">// represents a max-heap or not</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">NooB</code></div>
    <div class="line number4 index3 alt1"><code class="plain">&#123;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Returns true if arr[i..n-1]</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// represents a max-heap</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">boolean</code> <code class="plain">isHeap(</code><code
            class="keyword">int</code> <code class="plain">arr[],</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">i, </code><code class="keyword">int</code> <code
            class="plain">n)</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If a leaf node</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(i &gt;= (n - </code><code class="value">2</code><code
            class="plain">) / </code><code class="value">2</code><code class="plain">)</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="keyword">true</code><code class="plain">;</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If an internal node and</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// is greater than its</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// children, and same is</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// recursively true for the</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// children</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(arr[i] &gt;= arr[</code><code class="value">2</code> <code
            class="plain">* i + </code><code class="value">1</code><code class="plain">]</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&amp;&amp; arr[i] &gt;= arr[</code><code class="value">2</code> <code
            class="plain">* i + </code><code class="value">2</code><code class="plain">]</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&amp;&amp; isHeap(arr, </code><code class="value">2</code> <code
            class="plain">* i + </code><code class="value">1</code><code class="plain">, n)</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&amp;&amp; isHeap(arr, </code><code class="value">2</code> <code
            class="plain">* i + </code><code class="value">2</code><code class="plain">, n))</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="keyword">true</code><code class="plain">;</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number29 index28 alt2">&nbsp;</div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="keyword">false</code><code class="plain">;</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Driver program</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String[] args)</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">arr[] = &#123; </code><code class="value">90</code><code
            class="plain">, </code><code class="value">15</code><code class="plain">, </code><code
            class="value">10</code><code class="plain">, </code><code class="value">7</code><code
            class="plain">, </code><code class="value">12</code><code class="plain">, </code><code
            class="value">2</code><code class="plain">, </code><code class="value">7</code><code
            class="plain">, </code><code class="value">3</code> <code class="plain">&#125;;</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">n = arr.length - </code><code class="value">1</code><code
            class="plain">;</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(isHeap(arr, </code><code class="value">0</code><code
            class="plain">, n)) &#123;</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Yes"</code><code class="plain">);</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code> <code class="plain">&#123;</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"No"</code><code class="plain">);</code></div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number45 index44 alt2"><code class="plain">&#125;</code></div>
    <div class="line number46 index45 alt1">&nbsp;</div>
    <div class="line number47 index46 alt2"><code class="comments">// This code contributed by 29AjayKumar</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 program to check whether a</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># given array represents a max-heap or not</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="comments"># Returns true if arr[i..n-1]</code></div>
    <div class="line number5 index4 alt2"><code class="comments"># represents a max-heap</code></div>
    <div class="line number6 index5 alt1"><code class="keyword">def</code> <code class="plain">isHeap(arr, i, n):</code>
    </div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number8 index7 alt1"><code class="comments"># If a leaf node</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">i &gt;</code><code class="keyword">=</code> <code
            class="functions">int</code><code class="plain">((n </code><code class="keyword">-</code> <code
            class="value">2</code><code class="plain">) </code><code class="keyword">/</code> <code
            class="value">2</code><code class="plain">):</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">True</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># If an internal node and is greater</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># than its children, and same is</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># recursively true for the children</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code><code class="plain">(arr[i] &gt;</code><code class="keyword">=</code> <code
            class="plain">arr[</code><code class="value">2</code> <code class="keyword">*</code> <code
            class="plain">i </code><code class="keyword">+</code> <code class="value">1</code><code
            class="plain">] </code><code class="keyword">and</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">arr[i] &gt;</code><code class="keyword">=</code> <code class="plain">arr[</code><code
            class="value">2</code> <code class="keyword">*</code> <code class="plain">i </code><code
            class="keyword">+</code> <code class="value">2</code><code class="plain">] </code><code
            class="keyword">and</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">isHeap(arr, </code><code class="value">2</code> <code class="keyword">*</code> <code
            class="plain">i </code><code class="keyword">+</code> <code class="value">1</code><code
            class="plain">, n) </code><code class="keyword">and</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">isHeap(arr, </code><code class="value">2</code> <code class="keyword">*</code> <code
            class="plain">i </code><code class="keyword">+</code> <code class="value">2</code><code
            class="plain">, n)):</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">True</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">False</code></div>
    <div class="line number22 index21 alt1">&nbsp;</div>
    <div class="line number23 index22 alt2"><code class="comments"># Driver Code</code></div>
    <div class="line number24 index23 alt1"><code class="keyword">if</code> <code class="plain">__name__ </code><code
            class="keyword">=</code><code class="keyword">=</code> <code class="string">'__main__'</code><code
            class="plain">:</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">arr </code><code class="keyword">=</code> <code class="plain">[</code><code
            class="value">90</code><code class="plain">, </code><code class="value">15</code><code
            class="plain">, </code><code class="value">10</code><code class="plain">, </code><code
            class="value">7</code><code class="plain">, </code><code class="value">12</code><code
            class="plain">, </code><code class="value">2</code><code class="plain">, </code><code
            class="value">7</code><code class="plain">, </code><code class="value">3</code><code class="plain">]</code>
    </div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n </code><code class="keyword">=</code> <code class="functions">len</code><code
            class="plain">(arr) </code><code class="keyword">-</code> <code class="value">1</code></div>
    <div class="line number27 index26 alt2">&nbsp;</div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">isHeap(arr, </code><code class="value">0</code><code
            class="plain">, n):</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code class="string">"Yes"</code><code
            class="plain">)</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code class="string">"No"</code><code
            class="plain">)</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="comments"># This code is contributed by PranchalK</code></div>
</div>
 </div>

 </div>
</div>
<br /> <br /> <br /> <br /> <br />
    </div>
    )
}

export default Cis9
